import { graphql, useStaticQuery } from "gatsby";

import { BreadcrumbQuery } from "../../graphql-types";

export default function useData() {
  const { website } = useStaticQuery<BreadcrumbQuery>(graphql`
    query Breadcrumb {
      website {
        absolutePath
      }
    }
  `);

  if (!website) {
    throw new Error("Could not query data");
  }
  return { website };
}
